import { useQuery } from '@tanstack/react-query';
import {
  fetchMinerRewardNodes,
  type MinerRewardNodesResponse,
} from '../lib/minerApi.js';

export function useMinerRewardNodes(
  address: string | null,
  epochId: number | null,
) {
  return useQuery<MinerRewardNodesResponse | null>({
    queryKey: ['miner-reward-nodes', address, epochId],
    queryFn: async () => {
      if (!address || epochId === null) return null;
      return fetchMinerRewardNodes(address, epochId);
    },
    enabled: !!address && epochId !== null,
    staleTime: 300_000,
    retry: 1,
  });
}
